const DOMAIN_API_MAP = {
  'www.sctp.com.tr': 'https://panel.sctp.com.tr/api/',
  'sctp.com.tr': 'https://panel.sctp.com.tr/api/',
  'bigu.birlesikgumrukleme.com.tr':
    'https://panel.birlesikgumrukleme.com.tr/api/',
  // Dev ortamları
  localhost: 'https://localhost:44378/api/',
  '127.0.0.1': 'https://localhost:44378/api/',
};

export default DOMAIN_API_MAP;
